<template>
  <div
    v-if="tickets.variants"
    class="type-tickets-select-without-hall--select-block"
  >
    <div class="type-tickets-select-without-hall--select-list">
      <div
        :key="`${variant.name}-${index}`"
        v-for="(variant, index) in tickets.variants"
        class="type-tickets-select-without-hall--select-list-item"
      >
        <div
          class="type-tickets-select-without-hall--select-list-item-select-name-variant"
        >
          <p>{{ variant.Name }}</p>
        </div>

        <div class="type-tickets-select-without-hall--select-list-item-info">
          <p v-if="variant.Sum">{{ variant.Sum }} {{ setting.currency }}</p>
          <p v-else>Бесплатно</p>
        </div>

        <div class="type-tickets-select-without-hall--select-list-item-select">
          <div
            class="type-tickets-select-without-hall--select-list-item-select-minus"
            @click="() => decreaseTicketTypeHandler(tickets, variant)"
          ></div>
          <div
            class="type-tickets-select-without-hall--select-list-item-select-count"
          >
            <p>
              {{
                cart.tickets.filter(({ Name }) => Name === variant.Name).length
              }}
            </p>
          </div>
          <div
            class="type-tickets-select-without-hall--select-list-item-select-plus"
            @click="() => increaseTicketTypeHandler(tickets, variant)"
          ></div>
        </div>
      </div>
    </div>

    {{ log(places) }}
    <!-- {{log(places())}} -->
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { types } from '@/types';

export default {
  name: 'selectPlaceWithoutHall',

  computed: {
    ...mapState(['session', 'cart', 'errors', 'places', 'setting']),

    tickets() {
      if (!!this.session.Prices && this.session.Prices.length) {
        // console.log(this.session.Prices)

        const sessionPriceList = this.session.Prices.map(item => ({
          ticketId: item.TicketId,
          name: item.Name,
          id: item.Id,
          variants: [
            ...item.Discounts,
            { TicketId: item.TicketId, Name: item.TicketName, Sum: item.Sum },
          ],
        }))[0];

        // console.log({
        //   ...sessionPriceList,
        //   variants: sessionPriceList.variants.sort((a, b) => a.TicketId - b.TicketId),
        // })

        return {
          ...sessionPriceList,
          variants: sessionPriceList.variants.sort(
            (a, b) => a.TicketId - b.TicketId,
          ),
        };
      }
    },
  },

  methods: {
    log: m => console.log(m),
    decreaseTicketTypeHandler: function(tickets, variant) {
      const index = this.cart.tickets.findIndex(
        ({ Name }) => Name === variant.Name,
      );

      console.log(this.cart.tickets, variant);

      console.log(index);

      this.$store.dispatch('logRemoveTicket', {
        place: {
          name: this.cart.tickets[index].name,
          id: this.cart.tickets[index].id,
          Name: variant.Name,
          number: this.cart.tickets[index].number,
          price: variant.Sum,
          row: this.cart.tickets[index].row,
          typeId: variant.TicketId,
          variants: [
            {
              Name: variant.Name,
              Sum: variant.Sum,
              typeId: variant.TicketId,
            },
          ],
        },
        index,
      });
    },
    increaseTicketTypeHandler: function(tickets, variant) {
      let currentCartTicketCount = this.cart.tickets.length;
      let maxSeats = this.setting.maxSeats ? this.setting.maxSeats : 5;

      const freePlaces = this.places.filter(
        ({ Status, FragmentId, ticketId, Number, Row }) =>
          Status === 1 &&
          !FragmentId &&
          ticketId === tickets.TypeId &&
          this.cart.tickets.every(
            ticketInBucket =>
              ticketInBucket.row != Row || ticketInBucket.number != Number,
          ),
      );

      if (currentCartTicketCount === maxSeats) {
        this.$store.commit(
          types.ADD_ERROR,
          `Максимальное возможное количество мест для выбора не должно превышать ${maxSeats}шт.`,
        );
        this.$store.commit(types.CLEAR_ERRORS, 3000);

        return;
      }

      console.log(tickets, variant);

      this.$store.dispatch('logAddTicket', {
        place: {
          name: tickets.name,
          id: freePlaces[0].Id,
          Name: variant.Name,
          number: freePlaces[0].Number,
          price: variant.Sum,
          row: freePlaces[0].Row,
          typeId: variant.TicketId,
          variants: [
            {
              Name: variant.Name,
              Sum: variant.Sum,
              typeId: variant.TicketId,
            },
          ],
        },
      });
    },
  },
};
</script>

<style lang="scss">
.type-tickets-select-without-hall {
  &--wrapper {
    // position: absolute;
    bottom: 0;
    width: 100%;
    z-index: 9;
    &.selectTypeTicketsStep {
      padding-top: 15px;
      border-top: 1px solid #3b3d43;
      min-height: 10px;
    }
  }

  &--switch-control {
    display: block;
    position: absolute;
    top: 12px;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 26px;
    height: 11px;
    // transition: all 0.05s;
    padding: 1rem;
    cursor: pointer;
    &.close {
      transform: translate(-50%, -50%) rotate(180deg);
    }
  }

  &--select-block {
    background: #24262c;
    width: 100%;
    transition: all 0.5s;
    & > :not(:first-child) {
      border-top: 1px solid #3b3d43;
    }
  }

  &--select-list {
    min-height: 82px;
    background: #24262c;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    &-item {
      margin: 10px 0;
      display: flex;
      width: 100%;
      padding: 0 16px;
      min-height: 62px;
      border-bottom: 2px solid #3b3d43;
      align-items: center;
      &-select {
        display: flex;
        justify-content: center;
        align-items: center;
        &-minus,
        &-plus {
          width: 16px;
          height: 16px;
          border: 2px solid #ffffff;
          border-radius: 50%;
          position: relative;
          cursor: pointer;
          &:before,
          &:after {
            position: absolute;
            left: 50%;
            top: 50%;
            background: #fff;
            content: '';
          }
          &:before {
            width: 7.5px;
            height: 2px;
            transform: translate(-50%, -50%);
          }
        }

        &-plus {
          &:after {
            width: 7.5px;
            height: 2px;
            transform: translate(-50%, -50%) rotate(90deg);
          }
        }

        &-count,
        &-name-variant {
          font-size: 18px;
          line-height: 21px;
          color: #ffffff;
        }

        &-count {
          margin: 0 28px;
        }
      }
      &-info {
        font-size: 18px;
        line-height: 21px;
        color: #8f9193;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-left: auto;
        margin-right: 24px;
      }
    }
  }
}

@media (min-width: 768px) {
  .type-tickets-select-without-hall {
    &--select-list {
      flex-direction: row;
      &-item {
        margin: 0;
      }
    }
  }
}
</style>
